<template>
    <div class="">

        <div class="col-sm-12  px-3 card ibox no-shadow employee-table-wrapper">
            <div class="row no-gutters py-2 mb-3 mt-3">
                <div class="col-sm-6  company-form-box-title" v-if="$acl['loan-advance/applications'] > 1">Loan/Advance
                </div>
                <div class="col-sm-6 text-right company-form-box-title" v-if="$acl['loan-advance/applications'] > 1">
                    <button class="btn btn-block btn-secondary tab-button" @click="addNew()">Add Loan / Advance</button>
                </div>
            </div>
            <!-- <b-overlay :show="showoverlay_list" rounded="sm">
                <div v-if="loans.length > 0" class=" p-4">

                    <div class="row table-head">
                        <div class="col-sm-2 font-weight-bold py-1">
                            Loan ID
                        </div>
                        <div class="col-sm-1 font-weight-bold py-1">
                            Type
                        </div>
                        <div class="col-sm-2 font-weight-bold py-2 text-right">
                            Amount
                        </div>
                        <div class="col-sm-2 font-weight-bold py-2">
                            Deduction Start Month
                        </div>
                        <div class="col-sm-2 font-weight-bold py-2">
                            Effective Date
                        </div>
                        <div class="col-sm-1 font-weight-bold py-2">
                            Tenure
                        </div>
                        <div class="col-sm-1 font-weight-bold py-2">
                            Status
                        </div>

                        <div class="col-sm-1 font-weight-bold py-2 text-right" v-if="flg > 0">
                            Actions
                        </div>
                    </div>

                    <div class="row table-row hover-bg" v-for="loan in loans" :key="loan.id">
                        <div class="col-sm-2 py-2 align-items-center d-flex">
                            <div class="">{{ loan.company_loan_id }}</div>
                        </div>
                        <div class="col-sm-1 py-2 align-items-center d-flex">
                            <div class="">{{ loan_types_drop[loan.loan_type] }}</div>
                        </div>
                        <div class="col-sm-2 py-2 text-right">
                            <div class="">{{ formatMoney(loan.loan_amount) }}</div>
                        </div>
                        <div class="col-sm-2 py-2 align-items-center d-flex">
                            <div>{{ loan.deduction_start_month }}</div>
                        </div>
                        <div class="col-sm-2 py-2 align-items-center d-flex">
                            <div>{{ loan.effective_date_of_loan }}</div>
                        </div>

                        <div class="col-sm-1 py-2 align-items-center d-flex">
                            <div>{{ loan.loan_tenure }} Month(s)</div>
                        </div>
                        <div class="col-sm-1 py-1 align-items-center d-flex">
                            <div>
                                {{ loan_stat_title_2[loan.status] }}
                            </div>

                        </div>
                        <div class="col-sm-1 clearfix py-2 text-right position-relative d-flex align-items-center justify-content-end"
                            v-if="flg > 0">
                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false"><b-icon
                                    icon="three-dots-vertical"></b-icon></a>
                            <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                <b-button-toolbar class="custom-btn-toolbar">
                                    <b-button-group class="d-flex flex-column flex-grow-1">
                                        <template v-if="$acl['loan-advance/applications'] > 1">
                                            <b-button class="border-0 rounded mb-1"
                                                v-if="loan.has_tx == 0 && (loan_stat_title[loan.status] == 'Applied' || loan_stat_title[loan.status] == 'Pause/Stopped' || loan_stat_title[loan.status] == 'Declined')"
                                                variant="outline-secondary" title="Edit Bank Account Info"
                                                @click="editLoanInfo(loan.id, 0, 2)">
                                                <i class="fas fa-check-double"></i> Approve
                                            </b-button>
                                            <b-button class="border-0 rounded mb-1" variant="outline-secondary"
                                                v-if="loan_stat_title[loan.status] == 'Applied' || loan_stat_title[loan.status] == 'Approved' || loan_stat_title[loan.status] == 'Pause/Stopped' || loan_stat_title[loan.status] == 'Declined'"
                                                title="Edit Bank Account Info" @click="editLoanInfo(loan.id, 0, 0)">
                                                <i class="fas fa-edit"></i>Edit
                                            </b-button>
                                            <b-button class="border-0 rounded mb-1"
                                                v-if="loan.has_tx == 0 && (loan_stat_title[loan.status] == 'Approved' || loan_stat_title[loan.status] == 'Declined' || loan_stat_title[loan.status] == 'Applied' || loan_stat_title[loan.status] == 'Pause/Stopped')"
                                                variant="outline-secondary" title="Edit Bank Account Info"
                                                @click="showDeleteModal(loan.id)">
                                                <i class="fas fa-times"></i> Delete
                                            </b-button>
                                            <b-button class="border-0 rounded mb-1"
                                                v-if="loan.has_tx == 0 && (loan_stat_title[loan.status] == 'Approved' || loan_stat_title[loan.status] == 'Declined')"
                                                variant="outline-secondary" title="Edit Bank Account Info"
                                                @click="editLoanInfo(loan.id, 0, 1)">
                                                <i class="fas fa-undo-alt"></i> Unapprove
                                            </b-button>
                                            <b-button class="border-0 rounded mb-1"
                                                v-if="loan.has_tx == 0 && (loan_stat_title[loan.status] == 'Applied' || loan_stat_title[loan.status] == 'Approved')"
                                                variant="outline-secondary" title="Edit Bank Account Info"
                                                @click="showDeclineModal(loan.id)">
                                                <i class="fas fa-ban"></i> Decline
                                            </b-button>
                                            <b-button class="border-0 rounded mb-1"
                                                v-if="loan_stat_title[loan.status] == 'Approved'"
                                                variant="outline-secondary" title="Edit Bank Account Info"
                                                @click="editLoanInfo(loan.id, 0, 3)">
                                                <i class="fas fa-pause"></i> Pause / Stop
                                            </b-button>
                                            <b-button class="border-0 rounded mb-1"
                                                v-if="loan_stat_title[loan.status] == 'Approved'"
                                                variant="outline-secondary" title="Edit Bank Account Info"
                                                @click="editLoanInfo(loan.id, 1, 0)">
                                                <i class="fas fa-money-bill-alt"></i> Manual Payment
                                            </b-button>
                                        </template>
<b-button class="border-0 rounded mb-1"
    v-if="loan_stat_title[loan.status] == 'Approved' || loan_stat_title[loan.status] == 'Returned' || loan_stat_title[loan.status] == 'Pause/Stopped'"
    variant="outline-secondary" title="Edit Bank Account Info" @click="showInstallment(loan)">
    <i class="fab fa-delicious"></i> Installments
</b-button>
<b-button class="border-0 rounded mb-1" variant="outline-secondary" title="Loan Details"
    @click="showLoanTransactions(loan.id)">
    <i class="fas fa-table"></i> Transactions
</b-button>
</b-button-group>
</b-button-toolbar>
</div>
</div>
</div>
</div>
<div v-else class=" p-4">
    Sorry no data to show.
</div>
</b-overlay> -->

            <b-overlay :show="showoverlay_list" rounded="sm">
                <!-- alpha fix- removed condition from here   -->
                <div class="">

                    <table class="table">
                        <thead>
                            <tr class="table-head">
                                <td class="font-weight-bold py-1">Loan ID</td>
                                <td class="font-weight-bold py-1">Type</td>
                                <td class="font-weight-bold py-2 text-right">Amount</td>
                                <td class="font-weight-bold py-2">Deduction Start Month</td>
                                <td class="font-weight-bold py-2">Effective Date</td>
                                <td class="font-weight-bold py-2">Tenure</td>
                                <td class="font-weight-bold py-2">Status</td>
                                <td class="font-weight-bold py-2 text-right" v-if="flg > 0">Actions</td>
                            </tr>
                        </thead>

                        <!-- alpha fix- added template and placed comntion here  -->
                        <template v-if="loans.length > 0">
                            <tbody>
                                <tr class="hover-bg table-row border-bottom mx-2" v-for="loan in loans" :key="loan.id">
                                    <td class="align-middle list-columns">{{ loan.company_loan_id }}</td>
                                    <td class="align-middle list-columns">{{ loan_types_drop[loan.loan_type] }}</td>
                                    <td class="align-middle list-columns text-right">{{ formatMoney(loan.loan_amount) }}
                                    </td>
                                    <td class="align-middle list-columns">{{ loan.deduction_start_month }}</td>
                                    <td class="align-middle list-columns">{{ loan.effective_date_of_loan }}</td>
                                    <td class="align-middle list-columns">{{ loan.loan_tenure }} Month(s)</td>
                                    <!-- // Abdullah26 added chnaged this  -->
                                    <!-- <td class="align-middle list-columns">{{ loan_stat_title_2[loan.status] }}</td> -->
                                    <td class="align-middle list-columns loan-status-column" :class="getLoanStatusClass(loan.status)">
                                        <span>{{ loan_stat_title_2[loan.status] }}</span>
                                    </td>
                                    <td class="align-middle list-columns text-right" v-if="flg > 0">
                                        <b-button-toolbar class="position-relative text-right justify-content-end">
                                            <a id="actionDropdown"
                                                class="dropdown-toggle clearfix action-dropdown-toggle"
                                                style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                <b-icon icon="three-dots-vertical"></b-icon>
                                            </a>
                                            <div class="dropdown-menu action-dropdown-menu"
                                                aria-labelledby="actionDropdown">
                                                <b-button-group class="d-flex flex-column flex-grow-1">
                                                    <template v-if="$acl['loan-advance/applications'] > 1">
                                                        <!-- alpha fix- chnaged icon here  -->
                                                        <b-button class="border-0 rounded mb-1"
                                                            v-if="loan.has_tx == 0 && (loan_stat_title[loan.status] == 'Applied' || loan_stat_title[loan.status] == 'Pause/Stopped' || loan_stat_title[loan.status] == 'Declined')"
                                                            variant="outline-secondary"
                                                            @click="editLoanInfo(loan.id, 0, 2)">
                                                            <i class="fas fa-check"></i> Approve
                                                        </b-button>
                                                        <!-- alpha fix- chnaged icon here  -->
                                                        <b-button class="border-0 rounded mb-1"
                                                            v-if="loan_stat_title[loan.status] == 'Applied' || loan_stat_title[loan.status] == 'Approved' || loan_stat_title[loan.status] == 'Pause/Stopped' || loan_stat_title[loan.status] == 'Declined'"
                                                            variant="outline-secondary"
                                                            @click="editLoanInfo(loan.id, 0, 0)">
                                                            <b-icon icon="pencil"></b-icon> Edit
                                                        </b-button>
                                                        <!-- alpha fix- chnaged icon  -->
                                                        <b-button class="border-0 rounded mb-1" v-if="loan.has_tx == 0 && (
                                                            loan_stat_title[loan.status] == 'Approved' ||
                                                            loan_stat_title[loan.status] == 'Declined' ||
                                                            loan_stat_title[loan.status] == 'Applied' ||
                                                            loan_stat_title[loan.status] == 'Pause/Stopped'
                                                        )" variant="outline-secondary"
                                                            @click="showDeleteModal(loan.id)">
                                                            <b-icon icon="trash" aria-hidden="true"
                                                                class="mr-1"></b-icon>
                                                            Delete
                                                        </b-button>
                                                        <b-button class="border-0 rounded mb-1"
                                                            v-if="loan.has_tx == 0 && (loan_stat_title[loan.status] == 'Approved' || loan_stat_title[loan.status] == 'Declined')"
                                                            variant="outline-secondary"
                                                            @click="editLoanInfo(loan.id, 0, 1)">
                                                            <i class="fas fa-undo-alt"></i> Unapprove
                                                        </b-button>
                                                        <b-button class="border-0 rounded mb-1"
                                                            v-if="loan.has_tx == 0 && (loan_stat_title[loan.status] == 'Applied' || loan_stat_title[loan.status] == 'Approved')"
                                                            variant="outline-secondary"
                                                            @click="showDeclineModal(loan.id)">
                                                            <i class="fas fa-ban"></i> Decline
                                                        </b-button>
                                                        <b-button class="border-0 rounded mb-1"
                                                            v-if="loan_stat_title[loan.status] == 'Approved'"
                                                            variant="outline-secondary"
                                                            @click="editLoanInfo(loan.id, 0, 3)">
                                                            <i class="fas fa-pause"></i> Pause / Stop
                                                        </b-button>
                                                        <b-button class="border-0 rounded mb-1 text-nowrap"
                                                            v-if="loan_stat_title[loan.status] == 'Approved'"
                                                            variant="outline-secondary"
                                                            @click="editLoanInfo(loan.id, 1, 0)">
                                                            <i class="fas fa-money-bill-alt"></i> Manual Payment
                                                        </b-button>
                                                    </template>
                                                    <b-button class="border-0 rounded mb-1"
                                                        v-if="loan_stat_title[loan.status] == 'Approved' || loan_stat_title[loan.status] == 'Returned' || loan_stat_title[loan.status] == 'Pause/Stopped'"
                                                        variant="outline-secondary" @click="showInstallment(loan)">
                                                        <i class="fab fa-delicious mr-2"></i> Installments
                                                    </b-button>
                                                    <b-button class="border-0 rounded mb-1" variant="outline-secondary"
                                                        @click="showLoanTransactions(loan.id)">
                                                        <i class="fas fa-table"></i> Transactions
                                                    </b-button>
                                                </b-button-group>
                                            </div>
                                        </b-button-toolbar>
                                    </td>
                                </tr>
                            </tbody>
                        </template>

                        <!-- alpha fix- added template  -->
                        <template v-else>
                            <tr class="hover-bg table-row">
                                <td class="cursor-pointer trz_relative text-center" colspan="8"> Sorry no data to show.
                                </td>
                            </tr>
                        </template>

                    </table>

                </div>

            </b-overlay>
        </div>




        <b-modal id="decline-modal" title="Are you sure you want to decline this Loan/Advance ?" hide-footer>
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"
                @click="pauseLoan(loan_entity_id)">Decline
                <span v-if="loading != ''"><img :src="this.$api_url + '/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block
                @click="$bvModal.hide('decline-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>
        <b-modal id="delete-modal" title="Are you sure you want to delete this Loan/Advance ?" hide-footer>
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"
                @click="deleteLoan(loan_entity_id)">Delete
                <span v-if="loading != ''"><img :src="this.$api_url + '/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block
                @click="$bvModal.hide('delete-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

        <b-modal id="bv-modal-loan" size="lg" :modal-class="'w-600'" hide-footer v-bind:title="modal_title">
            <loan-form :flg="flg" :employee_id="this.employee_id" :key="count" :count="count" :loan_id="loan_id"
                :is_custom="is_custom" :is_status="is_status" v-on:childToParent="updateLoanData"></loan-form>
        </b-modal>


        <!-- <b-modal id="installment-modal" title="Installment Breakdown" hide-footer>
            <div class="row table-head">
                <div class="col-sm-4 font-weight-bold py-2">
                    Installment No.
                </div>
                <div class="col-sm-4 font-weight-bold py-2">
                    Month
                </div>
                <div class="col-sm-4 font-weight-bold py-2">
                    Amount
                </div>
            </div>
            <div class="row table-row hover-bg" v-for="(row, index) in my_installments" :key="index">
                <div class="col-sm-4 py-2 align-items-center d-flex">
                    <div :style="(row.status == 3) ? styleA : styleB">Installement #{{ index + 1 }}</div>
                </div>
                <div class="col-sm-4 py-2 align-items-center d-flex"
                    v-bind:style="[(row.status == 3) ? { styleA } : { styleB }]">
                    <div :style="(row.status == 3) ? styleA : styleB">{{ formatMoney(row.month) }}</div>
                </div>
                <div class="col-sm-4 py-2 align-items-center d-flex"
                    v-bind:style="[(row.status == 3) ? { styleA } : { styleB }]">
                    <div :style="(row.status == 3) ? styleA : styleB">{{ formatMoney(row.amount) }}</div>
                </div>
            </div>
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block
                @click="$bvModal.hide('installment-modal')">Close</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal> -->

        <!-- Abdullah26 chnaged the view to a table  -->
        <b-modal id="installment-modal" title="Installment Breakdown" hide-footer>
            <table class="table">
                <thead>
                    <tr class="table-head">
                        <td class="font-weight-bold py-2">Installment No.</td>
                        <td class="font-weight-bold py-2">Month</td>
                        <td class="font-weight-bold py-2">Amount</td>
                    </tr>
                </thead>
                <tbody>
                    <tr class="hover-bg table-row border-bottom mx-2" v-for="(row, index) in my_installments"
                        :key="index">
                        <td class="align-middle list-columns" :style="(row.status == 3) ? styleA : styleB">
                            Installement #{{ index + 1 }}
                        </td>
                        <td class="align-middle list-columns" :style="(row.status == 3) ? styleA : styleB">
                            {{ formatMoney(row.month) }}
                        </td>
                        <!-- alpha fix- added text right here  -->
                        <td class="align-middle list-columns text-right" :style="(row.status == 3) ? styleA : styleB">
                            {{ formatMoney(row.amount) }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block
                @click="$bvModal.hide('installment-modal')">Close</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

        <b-modal id="bv-modal-loan-transactions-wizard" size="lg" hide-footer v-bind:title="modal_title">
            <loan-transaction-wizard :key="tx_popup_count" :loan_id="loan_id"></loan-transaction-wizard>
        </b-modal>
    </div>
</template>


<script>
export default {

    mounted() {

    },
    props: ['bn', 'flg', 'employee_id'],
    data() {

        return {

            loans: [],
            styleA: 'color:#55ce63 !important',
            styleB: 'color:#212529 !important',
            is_status: '',
            loan_stat_title: ["Declined", "Applied", "Approved", "Pause/Stopped", "Returned"],
            loan_stat_title_2: ["Declined", "Applied", "Open", "Pause/Stopped", "Closed"],
            loan_stat_div: ["text-danger", "text-info", "text-success", "text-muted", "text-purple"],
            default_tenure: [0, 12, 1],
            showoverlay_list: false,
            disableme: false,
            disable_submit: false,
            successmsg: '',
            errormsg: [],
            selected_bank_id: 0,
            loading: '',
            loan_title: '',
            amount_title: '',
            showoverlaymodal: false,
            loan_entity_id: '',
            loan_update_status: '',
            loan_type: 1,
            loan_id: 0,
            modal_title: "",
            is_custom: 0,
            my_installments: [],
            count: 0,
            loan_types_drop: ['', 'Loan', 'Advance'],
            loan_status: [
                { value: null, text: "Select..." },
                { value: "0", text: "Decline" },
                { value: "1", text: "Applied" },
                { value: "2", text: "Approve" },
                { value: "3", text: "Pause/Stop" },
            ],
            loan_type_vals: [
                { value: "1", text: "Loan" },
                { value: "2", text: "Advance" },

            ],
            m_lists: [],
            tx_popup_count: 0,
        }
    },
    methods: {


        showApproveModal: function (pageflg) {
            this.loan_entity_id = pageflg;
            this.loan_update_status = 2;
            this.$bvModal.show('approve-modal');
        },
        showDeclineModal: function (pageflg) {
            this.loan_entity_id = pageflg;
            this.loan_update_status = 0;
            this.$bvModal.show('decline-modal');
        },
        showDeleteModal: function (pageflg) {
            this.loan_entity_id = pageflg;
            this.$bvModal.show('delete-modal');
        },
        getLoanStatusClass: function (status) {
            var label = this.loan_stat_title_2[status];
            if (!label) return '';
            return 'status-label status-label-' + label.toLowerCase().replace('/', '-');
        },
        showInstallment: function (loan) {
            if (!this.checkNet()) return false;
            let currentObj = this;
            let formData = new FormData();
            for (let [key, value] of Object.entries(loan)) {
                var nm = `${key}`;
                var fval = `${value}`;
                formData.append(nm, fval);
            }
            this.my_installments = [];
            this.showoverlay = true;
            axios.post(this.$api_url + '/loan-advance/installments', formData)
                .then(function (response) {
                    this.my_installments = response.data;
                    this.showoverlay = false;
                    this.$bvModal.show('installment-modal');

                }.bind(this)).catch(function (error) { currentObj.serverError(error); });

        },
        showLoanTransactions: function (loan_id) {
            this.loan_id = loan_id;
             this.modal_title = "Transactions"; // alpha fix- added, was inheriting stale title
            this.tx_popup_count = this.tx_popup_count + 1;
            this.$bvModal.show('bv-modal-loan-transactions-wizard');

        },
        pauseLoan: function (pageflg) {

            this.loading = 'load';
            var update_status = this.loan_update_status;
            let formData = new FormData();
            formData.append('loan_id', pageflg);
            formData.append('status', update_status);
            axios.post(this.$api_url + '/loan-update-status', formData)
                .then(function (response) {
                    this.$bvModal.hide('pause-modal');
                    this.$bvModal.hide('approve-modal');
                    this.$bvModal.hide('decline-modal');
                    this.loan_entity_id = '';
                    this.loan_update_status = '';
                    this.loading = '';
                    this.updateLoanData();
                }.bind(this))
                .catch(function (error) {
                    currentObj.showoverlay = false;
                    currentObj.serverError(error);
                });

        },
        deleteLoan: function (pageflg) {

            this.loading = 'load';

            let formData = new FormData();
            formData.append('loan_id', pageflg);

            axios.post(this.$api_url + '/loan-delete', formData)
                .then(function (response) {
                    this.$bvModal.hide('pause-modal');
                    this.$bvModal.hide('approve-modal');
                    this.$bvModal.hide('decline-modal');
                    this.$bvModal.hide('delete-modal');
                    this.loan_entity_id = '';
                    this.loan_update_status = '';
                    this.loading = '';
                    this.updateLoanData();
                }.bind(this))
                .catch(function (error) {
                    currentObj.showoverlay = false;
                    currentObj.serverError(error);
                });

        },
        updateLoanData: function () {
            this.$bvModal.hide('bv-modal-loan');
            this.loan_title = 'Employee Loan/Advance List';
            if (!this.checkNet()) return false;
            let currentObj = this;

            axios.get(this.$api_url + '/loan-advance/list', {
                params: {
                    employee_id: this.employee_id
                }
            }).then(function (response) {
                this.loans = response.data;

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });

        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        updateTransactions() {
            if (!this.checkNet()) return false;
            let currentObj = this;

            axios.get(this.$api_url + '/loan-advance/updatetransactions', {
                params: {
                    loan_type: 1
                }
            }).then(function (response) {
                this.updateLoanData();
            }.bind(this)).catch(function (error) { currentObj.serverError(error); });

        },
        addNew() {
            this.is_custom = 0;
            this.is_status = 0;
            this.loan_id = 0;
            this.count = this.count + 1;
            this.modal_title = "Add Loan/Advance";
            this.$bvModal.show('bv-modal-loan');

        },
        formatMoney: function (amount) {
            var money = Number(amount);
            money = money.toLocaleString();
            if (money == 'NaN')
                money = amount;
            else {
                if (money.indexOf(".") < 0)
                    money = money + ".00";
            }
            return money;
        },
        toMoney: function (amount) {
            if (amount != "0") {
                if (!isNaN(amount)) {
                    var number = Number(amount);
                    return number;
                }
                var NumWithoutCommas = amount.replace(/,/g, '');
                var number = Number(NumWithoutCommas).toFixed(2);
                return number;
            } else
                return amount;
        },
        editLoanInfo(loan_id, is_custom, status) {
        // alpha fix commented this
            // this.modal_title = "Edit Loan/Advance";

            // alpha fix- title now reflects which action triggered the modal
            if (is_custom) {
                this.modal_title = "Manual Payment";
            } else if (status == 1) {
                this.modal_title = "Unapprove Loan/Advance";
            } else if (status == 2) {
                this.modal_title = "Approve Loan/Advance";
            } else if (status == 3) {
                this.modal_title = "Pause / Stop Loan/Advance";
            } else {
                this.modal_title = "Edit Loan/Advance";
            }
            this.is_custom = is_custom;
            // alpha fix- added the else block
            if (is_custom) {
                this.modal_title = "Manual Payment";
            } else if (status == 1) {
                this.modal_title = "Unapprove Loan/Advance";
            }
            this.is_status = status;
            this.loan_id = loan_id;
            this.count = this.count + 1;
            this.$bvModal.show('bv-modal-loan');
        },
    },
    created: function () {
        this.updateTransactions();
    }
}
</script>
